import React, {useEffect, useState} from "react";
import { AC_LOCATIONS_EXTENSION, ExtensionType } from "../../Constants";
import {useGetSubExtensionFolioSubExtensionReferencesQuery} from "../../store/Api";
import {useGetGlobalStorefrontSettingsQuery} from "../../store/endpoints/StorefrontSettingsEndpoints";

import { IExtensionFolioSubextensionReference } from "../../models/Extension";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { SettingId } from "../../settings/registry";

interface ISubExtensionDropdownProps {
    type: ExtensionType;
    isGlobal?: boolean;
    extension?: string;
    onChange: (extension: string) => void;
    label?: string;
    includeWebhook?: boolean;
    /** Registry identifier, so documentation can deep-link to this field. */
    settingId?: SettingId;
}

const SubExtensionDropdown: React.FC<ISubExtensionDropdownProps> = (props) => {
    const subExtensions = useGetSubExtensionFolioSubExtensionReferencesQuery(props.type);
    const [extensionOptions, setExtensionOptions] = useState<IDropdownOption[]>()

    const globalSettingsApi = useGetGlobalStorefrontSettingsQuery();
    const change = (e: React.FormEvent<HTMLDivElement>, v?: IDropdownOption | undefined) => {
        if (v == null) return;
        props.onChange(v.key as string);
    }

    useEffect(() => {
        if(subExtensions.data && globalSettingsApi.data) {
            let globalOption: string | undefined;
            switch (props.type) {
                case ExtensionType.StorefrontOpportunity:
                    globalOption = globalSettingsApi.data?.opportunityExtension;
                    break;
                case ExtensionType.Customer:
                    globalOption = globalSettingsApi.data?.customerLookupExtension;
                    break;
                case ExtensionType.Locations:
                    globalOption = globalSettingsApi.data?.locationLookupExtension;
                    break;
                case ExtensionType.Tax:
                    globalOption = globalSettingsApi.data?.taxExtension;
                    break;
                default:
                    globalOption = undefined;
                    break;
            }
            const globalName = globalOption === AC_LOCATIONS_EXTENSION
                ? 'Adaptive Catalog Locations'
                : globalOption === 'DISABLED'
                    ? 'None (Disabled)'
                    : subExtensions.data.items.find((item: IExtensionFolioSubextensionReference) => `folio_${item.sourceFolio}_${item.identifier}` === globalOption)?.name;
            const text = props.isGlobal
                ? (globalName && globalName != '' ? globalName : 'Not Set')
                : (`${globalName ?? 'Not Set'} (Inherited from global settings)`);
            const options = [{key: '', text: text}, {key: 'DISABLED', text: 'None (Disabled)'},
                ...(props.type === ExtensionType.Locations ? [{key: AC_LOCATIONS_EXTENSION, text: 'Adaptive Catalog Locations'}] : []),
                ...(props.includeWebhook ? [{key: 'WEBHOOK', text: 'Webhook'}] : []),
                ...subExtensions.data.items.map((extension: IExtensionFolioSubextensionReference) => ({
                key: `folio_${extension.sourceFolio}_${extension.identifier}`,
                text: `(${extension.sourceFolio}) ${(extension.name ?? '')}`
            }))]
            setExtensionOptions(options);
        }
    }, [subExtensions.data, globalSettingsApi.data]);

    return (<div data-setting-id={props.settingId}>
        {(subExtensions.isLoading || subExtensions.isFetching) ? <></> :
            (extensionOptions && extensionOptions.length > 0) ?
                <Dropdown
                    label={props.label ?? 'Extension'}
                    selectedKey={props.extension ?? ''}
                    onChange={change}
                    options={extensionOptions}
                /> : <div> No Extensions Available</div>}
    </div>);
}

export default SubExtensionDropdown;